export default __webpack_public_path__ + "static/media/logo.2c436b2b.png";